import { AttachmentImageThumbnail } from "src/app/_models/image.model";
import { Comment } from "../_component/comment/comment.model";

export class Item {
    id: number;
    name: string; //50 len
    description: string; // 1000 len
    type: ItemType;    
    image?: AttachmentImageThumbnail = new AttachmentImageThumbnail();
    comments?: Comment[];
    rentalsCount: number;
    rentalStatus: RentalStatus;
    reservationCount: number;
}

export class ItemRental {
    id: number;
    idItem: number;
    idUser: number;
    dateCreated: Date;
    dateFrom?: Date;
    dateTo?: Date;
    status: RentalStatus

}

export enum ItemType {
    Book = 1
}

export enum RentalStatus{
    Available = 'AVAILABLE',
    Reservation = 'RESERVATION',
    Rent = 'RENT',
    Return = 'RETURN'
}




// nowa tabelka (item)
// nazwa
// opis,
// subtype->kategoria,
// typ, (książka)
// zdjęcie,

// (status na podstawie item_rental, data wypożyczenia do xx.yy)

// powiązane z comments

// item_rental (administrator odklikuje wypożeczenie i termin zwrotu, administartor przyjmuje książke
// id,
// id_item
// id_user (kto chce wypozyczyc)
// data (kiedy kilkal, ze chce wypozyczyc)
// data_od (od kiedy wypożyczył
// data_do (do kiedy ma zwrócić)
// status (rezerwacja, wypożyczył, zwrócił)